import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  tableWrap: {
    marginTop: 16,
    border: `1px solid ${Colors.Grey3}`,
    borderRadius: 0,
    overflow: 'hidden',
  },
  table: {
    width: '100%',
  },
  headerRow: {
    backgroundColor: Colors.Grey2,
  },
  headerText: {
    fontFamily: 'Readex Pro',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.56px',
    color: Colors.Grey10,
  },
  headerCellLeft: {
    padding: '16px 16px 17px',
    borderBottom: `1px solid ${Colors.Grey3}`,
  },
  headerCell: {
    padding: '16px 16px 17px',
    borderBottom: `1px solid ${Colors.Grey3}`,
    width: 160,
  },
  headerCellAction: {
    padding: '16px 16px 17px',
    borderBottom: `1px solid ${Colors.Grey3}`,
    width: 140,
  },
  bodyRow: {
    '& td': {
      borderBottom: `1px solid rgba(0,0,0,0.06)`,
    },
  },
  bodyCellLeft: {
    padding: '16px',
  },
  bodyCell: {
    padding: '16px',
    verticalAlign: 'top',
  },
  bodyCellAction: {
    padding: '16px 8px',
    verticalAlign: 'top',
  },
  linkText: {
    marginTop: 4,
    color: Colors.Grey6,
    maxWidth: 520,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  statusText: {
    fontFamily: 'Readex Pro',
    fontSize: 12,
    fontWeight: 200,
    lineHeight: '18px',
    letterSpacing: '0.48px',
    color: Colors.Grey7,
  },
  statusInactive: {
    opacity: 0.5,
  },
  actionGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  iconBtn: {
    padding: 8,
    borderRadius: 2,
    backgroundColor: Colors.White,
    '&:hover': {
      backgroundColor: Colors.Grey2,
    },
  },
  divider: {
    width: 1,
    height: 12,
    backgroundColor: 'rgba(0,0,0,0.06)',
  },
  loadingRow: {
    padding: 24,
    display: 'flex',
    justifyContent: 'center',
  },
  emptyRow: {
    padding: 24,
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useStyles;
